import { api } from "@/lib/lamka";

export const openConversation = (listingId) => api.post("/conversations", { listing_id: listingId }).then((r) => r.data);
export const listConversations = () => api.get("/conversations").then((r) => r.data);
export const getConversation = (id) => api.get(`/conversations/${id}`).then((r) => r.data);
// Normalise backend messages so a bubble never renders empty
export const normalizeMessage = (m, fallback = {}) => ({
  ...m,
  id: m?.id || m?._id || fallback.id,
  sender_id: m?.sender_id || m?.sender || m?.user_id || fallback.sender_id,
  text: m?.text ?? m?.content ?? m?.body ?? m?.message ?? fallback.text ?? "",
  created_at: m?.created_at || m?.timestamp || fallback.created_at || new Date().toISOString(),
});

export const listMessages = (id) =>
  api
    .get(`/conversations/${id}/messages`, { params: { _: Date.now() }, headers: { "Cache-Control": "no-cache" } })
    .then((r) => (Array.isArray(r.data) ? r.data : r.data.messages || r.data.items || []).map((m) => normalizeMessage(m)));
export const sendMessage = (id, text) =>
  api.post(`/conversations/${id}/messages`, { text }).then((r) => r.data?.message || r.data);
export const markRead = (id) =>
  api.post(`/conversations/${id}/read`).then(() => window.dispatchEvent(new Event("lamka:chat-read"))).catch(() => {});
export const getChatContact = (id) => api.get(`/conversations/${id}/contact`).then((r) => r.data);

export const timeLabel = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const sameDay = d.toDateString() === new Date().toDateString();
  return sameDay
    ? d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
    : d.toLocaleDateString([], { day: "numeric", month: "short" });
};
